import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/risk/rules',
    name: 'RiskRules',
    component: () => import('@/views/risk/rules.vue'),
    meta: {
      title: '规则配置',
      permission: 'risk:rules'
    }
  },
  {
    path: '/risk/alert',
    name: 'RiskAlert',
    component: () => import('@/views/risk/alert.vue'),
    meta: {
      title: '风险预警',
      permission: 'risk:alert'
    }
  },
  {
    path: '/risk/liquidation',
    name: 'RiskLiquidation',
    component: () => import('@/views/risk/liquidation.vue'),
    meta: {
      title: '强平操作',
      permission: 'risk:liquidation'
    }
  }
]

export default routes
